export default "<template>\n\n  <div style=\"width: 400px; padding: 24px 0\">\n    <KLinearLoader type=\"indeterminate\" />\n  </div>\n\n</template>\n";